"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Portal = _interopRequireDefault(require("../HOC/Portal"));
var _Button = _interopRequireDefault(require("../Button"));
var _Cross = _interopRequireDefault(require("../Icons/all/Cross"));
var _black = _interopRequireDefault(require("../tokens/color/black"));
var _white = _interopRequireDefault(require("../tokens/color/white"));
var _grey = _interopRequireDefault(require("../tokens/color/grey"));
var _noop2 = _interopRequireDefault(require("lodash-es/noop"));
var _get2 = _interopRequireDefault(require("lodash-es/get"));
var _misc = _interopRequireDefault(require("../tokens/misc"));
var _commonHelper = require("../helpers/commonHelper");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var modalWidth = {
  small: "20vw",
  medium: "40vw",
  large: "60vw",
  huge: "95vw",
  "default": "max-content"
};
var Modal = function Modal(_ref) {
  var mode = _ref.mode,
    onClose = _ref.onClose,
    visible = _ref.visible,
    type = _ref.type,
    children = _ref.children,
    isDialog = _ref.isDialog,
    onAccept = _ref.onAccept,
    onReject = _ref.onReject,
    acceptLabel = _ref.acceptLabel,
    rejectLabel = _ref.rejectLabel,
    title = _ref.title,
    showCloseIcon = _ref.showCloseIcon,
    slideOnMobile = _ref.slideOnMobile,
    isCentered = _ref.isCentered,
    titleComponent = _ref.titleComponent,
    padding = _ref.padding,
    overlayClickClose = _ref.overlayClickClose,
    maxHeight = _ref.maxHeight,
    minHeight = _ref.minHeight,
    enableScrollOnClose = _ref.enableScrollOnClose,
    className = _ref.className,
    showFooter = _ref.showFooter,
    renderFooter = _ref.renderFooter,
    overlayOpacity = _ref.overlayOpacity,
    flatModal = _ref.flatModal,
    extraCurved = _ref.extraCurved,
    mobileHeight = _ref.mobileHeight,
    autoHeight = _ref.autoHeight,
    bgColor = _ref.bgColor,
    preventFocus = _ref.preventFocus,
    useAbsoluteHeight = _ref.useAbsoluteHeight,
    zIndex = _ref.zIndex,
    id = _ref.id,
    isMobileDialog = _ref.isMobileDialog,
    borderRadius = _ref.borderRadius,
    isNavbar = _ref.isNavbar;
  var ref = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    document.body.style.overflow = visible ? "hidden" : "auto";
    return enableScrollOnClose ? function () {
      return document.body.style.overflow = "auto";
    } : _noop2["default"];
  }, [visible]);
  (0, _react.useEffect)(function () {
    if (visible && ref.current && !preventFocus) ref.current.focus();
  }, [visible]);
  var handleOnBlur = function handleOnBlur() {
    if (visible) ref.current.focus();
  };
  var handleKeyPress = function handleKeyPress(e) {
    e.stopPropagation();
    e.keyCode === 27 ? onClose(e) : null;
  };
  var handleOverlayClick = function handleOverlayClick(e) {
    return overlayClickClose && onClose(e);
  };

  // modal will be scrollable if mobileheight set to 0vh
  var onModalScroll = function onModalScroll(e) {
    if (!e.target.scrollTop && mobileHeight === "0vh" && e.target.classList.contains("modalWrapper")) {
      onClose(e); // scrollable modal will get close on full page scroll
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_Portal["default"], null, /*#__PURE__*/_react["default"].createElement(Modal.Wrapper, {
    className: "modalWrapper ".concat(className),
    "aria-hidden": visible ? "false" : "true",
    role: "dialog",
    visible: visible,
    autoHeight: autoHeight,
    useAbsoluteHeight: useAbsoluteHeight,
    onScroll: onModalScroll,
    zIndex: zIndex
  }, /*#__PURE__*/_react["default"].createElement(Modal.Overlay, {
    onClick: handleOverlayClick,
    visible: visible,
    tabIndex: "-1",
    overlayOpacity: overlayOpacity
  }), autoHeight && /*#__PURE__*/_react["default"].createElement(AutoHeightDiv, null), /*#__PURE__*/_react["default"].createElement(ModalContainer, {
    id: id,
    mode: mode,
    type: type,
    visible: visible,
    mobileHeight: mobileHeight,
    isDialog: isDialog,
    shouldSlide: slideOnMobile,
    isCentered: isCentered,
    padding: padding,
    tabIndex: "0",
    onKeyDown: handleKeyPress,
    ref: ref,
    flatModal: flatModal,
    extraCurved: extraCurved,
    autoHeight: autoHeight,
    bgColor: bgColor,
    isMobileDialog: isMobileDialog,
    borderRadius: borderRadius
  }, !isDialog && (title || titleComponent) && /*#__PURE__*/_react["default"].createElement(ModalContainer.Head, {
    padding: padding
  }, title ? /*#__PURE__*/_react["default"].createElement(ModalContainer.Title, {
    mode: mode
  }, title) : titleComponent ? titleComponent : null, showCloseIcon && /*#__PURE__*/_react["default"].createElement(StyledCross, {
    size: 24,
    color: mode === "dark" ? _grey["default"].z500 : _black["default"],
    showPointer: true,
    onClick: onClose,
    onKeyUp: (0, _commonHelper.onKeySelect)(onClose),
    tabIndex: "0",
    "aria-label": "close Modal"
  })), /*#__PURE__*/_react["default"].createElement(ModalContainer.Content, {
    visible: visible,
    maxHeight: maxHeight,
    minHeight: minHeight,
    isNavbar: isNavbar
  }, children), isDialog && /*#__PURE__*/_react["default"].createElement(ActionButtons, {
    rejectLabel: rejectLabel,
    acceptLabel: acceptLabel,
    onReject: onReject,
    onAccept: onAccept
  }), showFooter && renderFooter()), /*#__PURE__*/_react["default"].createElement(DummyDiv, {
    tabIndex: "0",
    onFocus: handleOnBlur
  })));
};
var getWindowHeight = function getWindowHeight() {
  return window.innerHeight;
};
var AutoHeightDiv = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  componentId: "sc-re4bd0-0"
})(["display:none;@media (max-width:480px){display:block;min-height:5vh;flex-grow:1;width:100%;}"]);
var StyledCross = /*#__PURE__*/(0, _styledComponents["default"])(_Cross["default"]).withConfig({
  componentId: "sc-re4bd0-1"
})(["max-height:3rem;height:3rem;width:3rem;display:flex;align-items:center;justify-content:center;border-radius:50%;"]);
var DummyDiv = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  componentId: "sc-re4bd0-2"
})(["height:0;width:0;"]);
var ActionButtons = function ActionButtons(props) {
  var _props$rejectLabel = props.rejectLabel,
    rejectLabel = _props$rejectLabel === void 0 ? "No" : _props$rejectLabel,
    _props$acceptLabel = props.acceptLabel,
    acceptLabel = _props$acceptLabel === void 0 ? "Yes" : _props$acceptLabel,
    _props$onReject = props.onReject,
    onReject = _props$onReject === void 0 ? _noop2["default"] : _props$onReject,
    _props$onAccept = props.onAccept,
    onAccept = _props$onAccept === void 0 ? _noop2["default"] : _props$onAccept;
  return /*#__PURE__*/_react["default"].createElement(ActionButtons.Wrapper, null, /*#__PURE__*/_react["default"].createElement(ActionButtons.Holder, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    appearance: "link",
    btnColor: "red",
    size: "small",
    onKeyUp: (0, _commonHelper.onKeySelect)(onReject),
    onClick: onReject,
    tabIndex: "0",
    role: "button"
  }, rejectLabel), /*#__PURE__*/_react["default"].createElement(ActionButtons.Gap, null), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    btnColor: "red",
    size: "small",
    onClick: onAccept,
    onKeyUp: (0, _commonHelper.onKeySelect)(onAccept),
    tabIndex: "0",
    role: "button"
  }, acceptLabel)));
};
ActionButtons.propTypes = {
  rejectLabel: _propTypes["default"].string,
  acceptLabel: _propTypes["default"].string,
  onAccept: _propTypes["default"].func,
  onReject: _propTypes["default"].func
};
ActionButtons.Holder = _styledComponents["default"].div.withConfig({
  componentId: "sc-re4bd0-3"
})(["display:flex;justify-content:flex-end;width:100%;min-width:max-content;margin-top:1rem;"]);
ActionButtons.Gap = _styledComponents["default"].div.withConfig({
  componentId: "sc-re4bd0-4"
})(["height:1rem;width:1rem;"]);
ActionButtons.Wrapper = _styledComponents["default"].div.withConfig({
  componentId: "sc-re4bd0-5"
})(["display:flex;"]);
Modal.Wrapper = _styledComponents["default"].div.withConfig({
  componentId: "sc-re4bd0-6"
})(["position:fixed;top:0;left:0;width:100%;min-width:max-content;height:", ";display:flex;justify-content:center;visibility:", ";overflow:auto;z-index:", ";", ""], function (props) {
  return props.useAbsoluteHeight ? "calc(".concat(getWindowHeight, ")") : "100%";
}, function (props) {
  return props.visible ? "visible" : "hidden";
}, function (props) {
  return props.zIndex || 11;
}, function (props) {
  return props.autoHeight && (0, _styledComponents.css)(["@media (max-width:480px){display:flex;flex-direction:column;}"]);
});
Modal.propTypes = {
  mode: _propTypes["default"].string,
  children: _propTypes["default"].node,
  onClose: _propTypes["default"].func,
  visible: _propTypes["default"].bool,
  isDialog: _propTypes["default"].bool,
  onAccept: _propTypes["default"].func,
  onReject: _propTypes["default"].func,
  rejectLabel: _propTypes["default"].string,
  acceptLabel: _propTypes["default"].string,
  title: _propTypes["default"].string,
  showCloseIcon: _propTypes["default"].bool,
  type: _propTypes["default"].oneOf(["small", "medium", "large", "huge", "default"]),
  slideOnMobile: _propTypes["default"].bool,
  isCentered: _propTypes["default"].bool,
  titleComponent: _propTypes["default"].node,
  padding: _propTypes["default"].string,
  overlayClickClose: _propTypes["default"].bool,
  maxHeight: _propTypes["default"].string,
  minHeight: _propTypes["default"].string,
  enableScrollOnClose: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  showFooter: _propTypes["default"].bool,
  renderFooter: _propTypes["default"].func,
  overlayOpacity: _propTypes["default"].number,
  flatModal: _propTypes["default"].bool,
  extraCurved: _propTypes["default"].bool,
  mobileHeight: _propTypes["default"].string,
  bgColor: _propTypes["default"].string,
  preventFocus: _propTypes["default"].bool,
  useAbsoluteHeight: _propTypes["default"].bool,
  zIndex: _propTypes["default"].number,
  id: _propTypes["default"].string,
  isMobileDialog: _propTypes["default"].bool,
  isNavbar: _propTypes["default"].bool,
  borderRadius: _propTypes["default"].string
};
Modal.defaultProps = {
  mode: "light",
  onClose: _noop2["default"],
  visible: false,
  type: "default",
  children: null,
  isDialog: false,
  onAccept: _noop2["default"],
  onReject: _noop2["default"],
  acceptLabel: "",
  rejectLabel: "",
  title: "",
  showCloseIcon: true,
  slideOnMobile: false,
  isCentered: false,
  titleComponent: null,
  padding: "",
  overlayClickClose: true,
  maxHeight: "",
  minHeight: "8rem",
  enableScrollOnClose: true,
  className: "",
  showFooter: false,
  renderFooter: _noop2["default"],
  overlayOpacity: 0.85,
  flatModal: false,
  extraCurved: false,
  mobileHeight: "95vh",
  bgColor: _white["default"],
  preventFocus: false,
  useAbsoluteHeight: false,
  zIndex: 11,
  id: "id-" + Math.floor(Math.random() * 100),
  isMobileDialog: false,
  borderRadius: "",
  isNavbar: false
};
var getModalWidth = function getModalWidth(_ref2) {
  var type = _ref2.type;
  return modalWidth[type];
};
var getModalMobileWidth = function getModalMobileWidth(_ref3) {
  var shouldSlide = _ref3.shouldSlide,
    isMobileDialog = _ref3.isMobileDialog;
  if (isMobileDialog) {
    return "80vw";
  }
  if (shouldSlide) {
    return "100vw";
  }
  return "95vw";
};
var getModalBorderRadius = function getModalBorderRadius(_ref4) {
  var borderRadius = _ref4.borderRadius,
    isMobileDialog = _ref4.isMobileDialog;
  if (borderRadius) {
    return borderRadius;
  } else if (isMobileDialog) {
    return "1.2rem";
  }
  return "unset";
};
var getOverflow = function getOverflow(props) {
  if (props.isNavbar) {
    return "unset";
  }
  if (props.maxHeight) {
    return "auto";
  }
  return "initial";
};
Modal.Overlay = _styledComponents["default"].div.withConfig({
  componentId: "sc-re4bd0-7"
})(["position:fixed;top:0;left:0;width:100%;height:100%;background-color:", ";opacity:", ";visibility:", ";transition:opacity ", " ease;"], _black["default"], function (props) {
  return props.visible ? props.overlayOpacity : 0;
}, function (props) {
  return props.visible ? "visible" : "hidden";
}, _misc["default"].animationDuration);
var ModalContainer = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  componentId: "sc-re4bd0-8"
})(["background-color:", ";height:max-content;transform:translate3d(0,0,0);@media (min-width:481px){width:", ";margin:", ";min-height:", ";min-width:20rem;border-radius:", ";transform:scale(", ");box-shadow:0 1.2rem 7rem rgba(28,28,28,0.15);transition:transform ", " ease;}@media (max-width:480px){width:", ";border-radius:", ";min-height:", ";margin:", ";", " ", "}opacity:1;z-index:1;display:", ";padding:", ";"], function (props) {
  return props.mode === "dark" ? _grey["default"].z900 : props.bgColor;
}, getModalWidth, function (props) {
  return props.isCentered ? "auto" : "5rem auto";
}, function (props) {
  return props.isDialog ? 0 : "150px";
}, function (props) {
  return props.borderRadius ? props.borderRadius : "0.6rem";
}, function (props) {
  return props.visible ? 1 : 1.2;
}, _misc["default"].animationDuration, getModalMobileWidth, getModalBorderRadius, function (props) {
  return props.shouldSlide ? props.mobileHeight : "auto";
}, function (props) {
  return props.isCentered ? "auto" : 0;
}, function (_ref5) {
  var flatModal = _ref5.flatModal,
    extraCurved = _ref5.extraCurved,
    shouldSlide = _ref5.shouldSlide;
  return shouldSlide && (0, _styledComponents.css)(["margin-top:", ";transition:all ", " ease,visibility 0ms ease;border-radius:", ";"], function (props) {
    return props.visible ? "calc(100vh - ".concat(props.mobileHeight, ")") : "100vh";
  }, _misc["default"].animationDuration, extraCurved ? "1.2rem 1.2rem 0 0" : !flatModal && "0.6rem 0.6rem 0 0");
}, function (_ref6) {
  var autoHeight = _ref6.autoHeight;
  return autoHeight && (0, _styledComponents.css)(["margin-top:0;min-height:0;"]);
}, function (props) {
  return props.visible ? "block" : "flex";
}, function (props) {
  return props.isDialog ? "2rem" : props.padding ? props.padding : 0;
});
ModalContainer.Head = _styledComponents["default"].section.withConfig({
  componentId: "sc-re4bd0-9"
})(["width:", ";display:flex;justify-content:space-between;align-items:center;margin:", ";@media (max-width:480px){width:", ";margin:", ";}"], function (props) {
  return props.padding ? "calc(100% + 0.5rem)" : "calc(100% - 4.6rem)";
}, function (props) {
  return props.padding ? "0" : "2rem 2.2rem 0 2.4rem";
}, function (props) {
  return props.padding ? "calc(100% + 0.5rem)" : "calc(100% - 2.6rem)";
}, function (props) {
  return props.padding ? "0" : "1rem 1.2rem 0 1.4rem";
});
ModalContainer.Title = _styledComponents["default"].h2.withConfig({
  componentId: "sc-re4bd0-10"
})(["font-size:2.4rem;line-height:2.8rem;font-weight:400;color:", ";margin-top:0.5rem;margin-bottom:0.83rem;"], function (props) {
  return props.mode === "dark" ? _white["default"] : _black["default"];
});
ModalContainer.Content = _styledComponents["default"].section.withConfig({
  componentId: "sc-re4bd0-11"
})(["display:", ";max-height:", ";overflow:", ";@media (max-width:480px){min-height:", ";}"], function (props) {
  return props.visible ? "block" : "none";
}, function (props) {
  return (0, _get2["default"])(props, "maxHeight", "fit-content");
}, function (props) {
  return getOverflow(props);
}, function (props) {
  return props.minHeight;
});
var _default = exports["default"] = Modal;